import Enumeration from "../domain/Enumeration";

const AgentPrivilege = new Enumeration({

    // Agent Privileges
    AGENT_PORTAL_REGISTRATION_CREATE: "AGENT-PORTAL-REGISTRATION-CREATE",
    AGENT_PORTAL_CUSTOMER_VIEW: "AGENT-PORTAL-CUSTOMER-VIEW",
    AGENT_PORTAL_PERSON_HISTORY_VIEW: "AGENT-PORTAL-PERSON-HISTORY-VIEW",
    AGENT_PORTAL_MSISDN_HISTORY_VIEW: "AGENT-PORTAL-MSISDN-HISTORY-VIEW",
    AGENT_PORTAL_CUSTOMER_LIMIT_VIEW: "AGENT-PORTAL-CUSTOMER-LIMIT-VIEW",
    AGENT_PORTAL_CUSTOMER_LIMIT_EDIT: "AGENT-PORTAL-CUSTOMER-LIMIT-EDIT",
    AGENT_PORTAL_OUTBOUND_TRANSACTION_VIEW: "AGENT-PORTAL-OUTBOUND-TRANSACTION-VIEW",
    AGENT_PORTAL_OUTBOUND_TRANSACTION_CREATE: "AGENT-PORTAL-OUTBOUND-TRANSACTION-CREATE",
    AGENT_PORTAL_BENEFICIARY_VIEW: "AGENT-PORTAL-BENEFICIARY-VIEW",
    AGENT_PORTAL_BENEFICIARY_EDIT: "AGENT-PORTAL-BENEFICIARY-EDIT",
    AGENT_PORTAL_BENEFICIARY_CREATE: "AGENT-PORTAL-BENEFICIARY-EDIT",
    AGENT_PORTAL_CARD_BATCH_VIEW: "AGENT-PORTAL-CARD-BATCH-VIEW",
    AGENT_PORTAL_CARD_BATCH_EDIT: "AGENT-PORTAL-CARD-BATCH-EDIT",
    AGENT_PORTAL_BANK_CARD_VIEW: "AGENT-PORTAL-BANK-CARD-VIEW",
    AGENT_PORTAL_BANK_CARD_EDIT: "AGENT-PORTAL-BANK-CARD-EDIT",
    AGENT_PORTAL_OUTBOUND_TRANSACTION_COMMISSION_SUMMARY_VIEW: "AGENT-PORTAL-OUTBOUND-TRANSACTION-COMMISSION-SUMMARY-VIEW",
    AGENT_PORTAL_REGISTRATION_CARD_QUESTION_VIEW: "AGENT-PORTAL-REGISTRATION-CARD-QUESTION-VIEW",
    AGENT_PORTAL_LINK_BANK_CARD_TO_BANK_ACCOUNT: "AGENT-PORTAL-LINK-BANK-CARD-TO-BANK-ACCOUNT",
    AGENT_PORTAL_AGENT_PAYMENT_DETAILS_EDIT: "AGENT-PORTAL-AGENT-PAYMENT-DETAILS-EDIT",
    AGENT_PORTAL_BANK_ACCOUNT_REQUEST: "AGENT-PORTAL-BANK-ACCOUNT-REQUEST",
    AGENT_PORTAL_TRANSACTION_CHAT_CREATE: "AGENT-PORTAL-TRANSACTION-CHAT-CREATE",
    AGENT_PORTAL_REGISTRATION_CHAT_CREATE: "AGENT-PORTAL-REGISTRATION-CHAT-CREATE",
    AGENT_PORTAL_CHAT_VIEW: "AGENT-PORTAL-CHAT-VIEW",
    AGENT_PORTAL_BANK_ACCOUNT_VIEW: "AGENT-PORTAL-BANK-ACCOUNT-VIEW",
    AGENT_PORTAL_AGENT_ANNOUNCEMENT_VIEW: "AGENT-PORTAL-AGENT-ANNOUNCEMENT-VIEW",
    AGENT_PORTAL_GENERATE_REFERRAL_LINK: "AGENT-PORTAL-GENERATE-REFERRAL-LINK",
    AGENT_PORTAL_MANAGED_AGENTS_MENU: "AGENT-PORTAL-MANAGED-AGENTS-MENU",
    AGENT_PORTAL_EDIT_PROFILE: "AGENT-PORTAL-EDIT-PROFILE",
    AGENT_PORTAL_VIEW_PROFILE: "AGENT-PORTAL-VIEW-PROFILE"
})

export default AgentPrivilege;
